import { css, html, LitElement } from 'lit-element';
import { pxToRem } from 'lm-ui-kit/src/utils/css-utils';
import { screenLgMin, screenSmMin } from 'lm-ui-kit/src/utils/response-query';
import { largeDesktop, mobile, onlyTablet } from '../utils';

export class UcFooterLinkBlock extends LitElement {
  static get styles() {
    return css`
      :host {
        display: grid;
        grid-template-rows: repeat(2, minmax(0px, 50px)) minmax(0, 70px) repeat(2, minmax(0px, 50px));
        grid-gap: ${pxToRem(16)};
        padding-top: ${pxToRem(16)};
      }

      @media (min-width: ${screenSmMin}px) and (max-width: ${screenLgMin}px) {
        :host {
          align-items: center;
          grid-template-columns: 1fr 180px 1fr;
          grid-template-rows: ${pxToRem(50)} ${pxToRem(50)};
          grid-row-gap: ${pxToRem(10)};
        }

        ::slotted(uc-footer-apps) {
          grid-area: 1 / 2 / 3 / 3;
        }

        ::slotted(uc-footer-subscribe) {
          grid-area: 2 / 1 / 3 / 2;
        }
   
        ::slotted(uc-footer-info) {
          grid-area: 3 / 1 / 4 / 2;    
  
        }

        ::slotted(uc-adeo-links) {
          grid-area: 1 / 3 / 2 / 4;
        }

        ::slotted(uc-payment-systems) {
          grid-area: 2 / 3 / 3 / 4;
        }

        ::slotted(uc-parent-link) {
          align-self: start;
          grid-area: 3 / 3 / 4 / 4;
        }
      }
    
      ${largeDesktop(css`
        :host {
          padding-top: 0;
        }
      `)}

      ${mobile(css`
        :host {
          grid-template-rows: minmax(0px, 50px) repeat(4, minmax(0px, auto));
        }
      `)}

      ${onlyTablet(css`
        ::slotted(uc-footer-info) {
           width: 100%;
           grid-area: 3 / 1 / 4 / 3;
           padding-right: 10%;
        }
      `)}  
    `;
  }

  render() {
    return html` <slot></slot> `;
  }
}
